const context = require.context('../wordmarks', true, /.svg$/);

const obj = {};
context.keys().forEach((key) => {
    const triCode = key
        .split('./')
        .pop() // remove the first 2 characters
        .substring(0, key.length - 15); // remove '_wordmark' and the file extension
    obj[triCode] = context(key);
});

export default obj;
